import script from "./AbsenceChartDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AbsenceChartDialog.vue?vue&type=script&setup=true&lang=js"

import "./AbsenceChartDialog.vue?vue&type=style&index=0&id=1252be05&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1252be05"]])

export default __exports__